import type { ViewProps as BaseProps } from "react-native"

import React from "react"
import { View as Base } from "react-native"

import type { WithOptionalTestId } from "./test-id"

import { testIds } from "./test-id"

export type ViewProps = WithOptionalTestId<BaseProps>

/**
 * Encapsulation of the React Native View component.
 */
export const View = React.forwardRef<Base, ViewProps>(function View(
  { id, ...rest },
  ref,
) {
  return <Base ref={ref} id={id} {...testIds(id)} {...rest} />
})
